/** Raw network values from Firestore / patient responsibility (camelCase). */
export enum CoverageNetworkTypes {
  IN_NETWORK = "inNetwork",
  OUT_NETWORK = "outNetwork",
  NO_NETWORK = "noNetwork",
  NOT_APPLICABLE = "notApplicable",
  NOT_APPLICABLE_NETWORK = "notApplicableNetwork",
}

/** Alternate raw values (snake_case) used by some payloads. */
export enum CoverageNetworkTypesSnake {
  IN_NETWORK = "in_network",
  OUT_NETWORK = "out_network",
  NO_NETWORK = "no_network",
  NOT_APPLICABLE = "not_applicable",
}

/** Normalized display / export strings for coverage UI. */
export enum CoverageNetworkDisplay {
  IN_NETWORK = "in-network",
  OUT_NETWORK = "out-of-network",
  NO_NETWORK = "no-network",
  NOT_APPLICABLE = "not-applicable",
  UNKNOWN = "unknown",
}

/**
 * Maps stored network type strings to {@link CoverageNetworkDisplay}.
 */
export const mapCoverageNetworkTypeToDisplay = (
  networkType: string | undefined,
): CoverageNetworkDisplay => {
  if (!networkType) {
    return CoverageNetworkDisplay.UNKNOWN;
  }
  switch (networkType) {
    case CoverageNetworkTypes.IN_NETWORK:
    case CoverageNetworkTypesSnake.IN_NETWORK:
      return CoverageNetworkDisplay.IN_NETWORK;
    case CoverageNetworkTypes.OUT_NETWORK:
    case CoverageNetworkTypesSnake.OUT_NETWORK:
      return CoverageNetworkDisplay.OUT_NETWORK;
    case CoverageNetworkTypes.NO_NETWORK:
    case CoverageNetworkTypesSnake.NO_NETWORK:
      return CoverageNetworkDisplay.NO_NETWORK;
    case CoverageNetworkTypes.NOT_APPLICABLE:
    case CoverageNetworkTypesSnake.NOT_APPLICABLE:
    case CoverageNetworkTypes.NOT_APPLICABLE_NETWORK:
      return CoverageNetworkDisplay.NOT_APPLICABLE;
    default:
      return CoverageNetworkDisplay.UNKNOWN;
  }
};
